import { Redirect, useParams } from 'react-router';
import { useClientCode } from '../hooks/api/useClientCode';
import { ROUTE_PATH } from './route-paths';
import { setSessionStorageItem } from '../hooks/utils/useSessionStorage';

export const GroupIdRouter = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const { data: clientCode, isLoading } = useClientCode({
    partnerCode: groupId,
  });

  // we absolutely need this to let useClientCode complete before redirecting
  if (isLoading) {
    return <></>;
  }

  clientCode && setSessionStorageItem('clientCode', groupId);
  clientCode && setSessionStorageItem('clientId', clientCode.client.id.toString());

  return <Redirect from={ROUTE_PATH.WELCOME_PAGE} to={ROUTE_PATH.WELCOME_PAGE} />;
};
